<template>
    <div class="opertorbg">
      <STable
          ref="tableref"
          :url="url"
          :selection="false"
          :columns="columns"
          :handles="handles"
          :query="query"
          :toolbar="toolbar"
          labelWidth="120px"
        ></STable>
    </div>
</template>
<script>
  import { mapState, mapMutations, mapAction } from "vuex";
  import { HOST, EV_HOST } from "@/utils/host";
  export default {
    name:"jigouguanli",
    data(){
      return{
        url:"/org/page",
        columns: [
          {
            label: "机构名称",
            prop: "name"
          },
          {
            label: "统一社会信用代码",
            prop: "code"
          },
          {
            label: "联系人",
            prop: "contactUser"
          },
          {
            label: "联系方式",
            prop: "contactNum"
          },
          {
            label: "邮箱",
            prop: "email"
          }
        ],
        handles:{
          width:200,
          btns:[
            {
              label:"详情",
              permission: "organizationalmanagement.pagetail",
              handle:res=>{
                this.$router.push({path:"./operatorDetail",query:{data:res.id}})
              }
            },
            // {
            //   label:"冻结",
            //   permission: "org.manager.freeze",
            //   style:"color:red",
            //   getLabel: function(record) {
            //     return record.frozen ? "恢复" : "冻结";
            //   },
            //   url: "/org/frozen",
            //   method: "post",
            //   isConfirm: true,
            //   confirmText: "是否确定本操作？",
            //   before: function(index, record) {
            //     let p = {
            //       id: record.id
            //     };
            //     return p;
            //   },
            //   handle: resp => {
            //     this.$refs.tableref.queryTable();
            //   }
            // },
            {
              label:"修改",
              permission: "organizationalmanagement.pageupdate",
              handle:res=>{
                this.$router.push({path:"./modifyOperatormanagement",query:{data:res.id}})
              }
            },
            {
              label:"删除",
              permission: "organizationalmanagement.delete",
              style:"color:red",
              url:"/org",
              method:"delete",
              confirmText: "删除机构会将该机构下的子机构一并删除，是否确定删除？",
              isConfirm: true,
              before:(index,record) => {
                let arr = [];
                arr.push(record.id);
                return {
                  ids:arr
                };
              },
              handle: () =>{
                this.$notify({
                  title: "成功",
                  message: "删除成功",
                  type: "success"
                });
                this.$refs.tableref.queryTable();
                this.$store.dispatch("login/getCur")
                this.$store.dispatch("login/getMenu")
              }
            }
          ]
        },
        query:[
          {
            label:"机构名称",
            prop:"name",
            placeholder:"请输入机构名称",
          },
          {
            label:"统一社会信用代码",
            prop:"code",
            placeholder:"请输入统一社会信用代码",
          },
          {
            label:"联系人",
            prop:"contactUser",
            placeholder:"请输入联系人",
          },
          {
            label:"联系方式",
            prop:"contactNum",
            placeholder:"请输入联系方式",
          },
          {
            label:"邮箱",
            prop:"email",
            placeholder:"请输入邮箱",
          },
        ],
        toolbar:[
          {
            label: "新增",
            permission: "organizationalmanagement.pageadd",
            type: "success",
            handle: resp => {
              this.$router.push("./addOperatormanagement")
            }
          }
        ]
      }
    }
  }
  </script>
  <style lang="less" src="" scoped>
  </style>



// WEBPACK FOOTER //
// src/views/BMS/organManagement/operatormanagement.vue